import Vue from 'vue';
import store from 'store/mainStore';
import 'es6-promise/auto';
import utils from 'js/services/utils';
import 'quasar/dist/quasar.umd.min';

Vue.use(utils);

(function(wv, undefined){
	wv.store = store;
	wv.passwordReset = new Vue({
		el: "#password-reset-wrapper",
		store,
		components: {
			'password-reset-main': () => import(/* webpackPrefetch: true */ 'components/passwordReset/passwordResetMain'),
		},
	});
}( window.wv = window.wv || {} ));